import { shallowEqual, useSelector } from 'react-redux';

export interface State {
  app: {
    context: {
      session: {
        loggedIn: boolean;
        account: {
          projectSpecificData: {
            customerGroupId: string;
          };
        };
      };
    };
  };
}

export const useUserContext = () => {
  return useSelector(
    (state: State) => ({
      loggedIn: state.app.context.session?.loggedIn,
      customerGroupId: state.app.context.session?.account?.projectSpecificData?.customerGroupId ?? null,
    }),
    shallowEqual,
  );
};
